import { Job } from '@/class/model/booking/Job'

export class AutoContaninerFactory {
  // 单例
  static _instace = null
  /**
   * 构造方法
   */
  constructor() {
    this.job = null
  }
  static getInstance() {
    if (!this._instace) {
      this._instace = new AutoContaninerFactory()
    }
    return this._instace
  }
  async init(job) {
    this.job = job
    if (job && job.uuid) {
      await new Job(job).loadPushHistoryLogs()
      this.loadPushHistoryLogsHandler()
    }
  }
  loadPushHistoryLogsHandler() { }
}
